<template>
  <div class="tab-body">
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        v-loading="listLoading"
      >
        <el-table-column prop="name" width="220" label="试卷名称">
          <template slot-scope="scope">
            <span :title="scope.row.name">{{ scope.row.dbColumn_expid }}</span>
          </template></el-table-column
        >
        <el-table-column
          prop="type"
          width="135"
          label="类型"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.type == 1" size="mini"
              >线下-{{
                scope.row.extype == 1
                  ? "小测"
                  : scope.row.extype == 2
                  ? "周测"
                  : "阶段测"
              }}
            </el-tag>
            <el-tag type="warning" v-else-if="scope.row.type == 2" size="mini"
              >模拟面试-{{
                scope.row.extype == 1
                  ? "小测"
                  : scope.row.extype == 2
                  ? "周测"
                  : "阶段测"
              }}</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.type == 4" size="mini"
              >面试轮训-{{
                scope.row.extype == 1
                  ? "小测"
                  : scope.row.extype == 2
                  ? "周测"
                  : "阶段测"
              }}</el-tag
            >  <el-tag type="danger" v-else-if="scope.row.type == 5" size="mini"
              > 覆盖考试</el-tag
            >
            <el-tag type="success" v-else size="mini"
              >线上-{{
                scope.row.extype == 1
                  ? "小测"
                  : scope.row.extype == 2
                  ? "周测"
                  :    scope.row.type == 6?"过关测": "阶段测"
              }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="isMobile" width="100" label="支持移动端">
          <template slot-scope="scope">
            {{ scope.row.isMobile == 1 ? "是" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="score"
          width="100"
          label="试卷总分"
          align="center"
        >
          <template slot-scope="scope">
            {{ (scope.row.type==2 ||scope.row.type==4) ?100:   scope.row.exscores }}
          </template>
        </el-table-column>
        <el-table-column
          prop="exduration"
          width="135"
          label="考试时长(分钟)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="开始-截止时间"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" type="success">
              {{ scope.row.startTime }}</el-tag
            >
            <el-tag size="mini" type="danger"> {{ scope.row.endTime }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="400px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button
                size="mini"
                type="success"
                v-if="isStart(scope.row)"
                @click="toStartTest(scope.$index, scope.row)"
                >开始考试</el-button
              >
              <el-button
                size="mini"
                :type="scope.row.isjudged ? 'info' : 'success'"
                v-if="scope.row.type == 4"
                :disabled="scope.row.isjudged ? true : false"
                @click="toInterview(scope.$index, scope.row)"
                >我将面试:{{ scope.row.myInterviewer}}
                {{ scope.row.myInterViewExam?"-(已完成)":"" }}
                </el-button
              >
              <el-tag
                size="small"
                type="info"
                effect="dark"
                v-if="scope.row.type == 4"
                >我的考官:{{ scope.row.toInterviewer }} {{ scope.row.myExam?"-(已完成)":"" }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <startTest ref="startTest" @closeExam="closeExam"></startTest>
    <correct ref="correct"></correct>
  </div>
</template>
<script>
import startTest from "./startTest.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import api from "@/api/exams/exams/exams.js";
import correct from "./correct2.vue";
export default {
  name: "exams",
  components: {
    startTest,
    selectOptionDictionary,
    correct,
  },
  data() {
    return {
      startTest: false,
      name: "",
      extype: "",
      searchParams: { type: 1 }, //是否为历史考试    历史考试 是什么？？？？
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      myInterview: "11",
      interview: "11",
    };
  },
  watch: {
    "searchParams.name": function () {
      this.search();
    },
  },

  methods: {
    //去面试另一位考生
    toInterview(idx, row) {
     // this.$utils.msg.warning("请打开weapp担当考官");
     console.log("row",row)
      this.$refs.correct.open(
        row.id,
        "正在对：" + row.toInterviewer + "  进行模拟面试",
        false,
        row.stuid,
        row.toInterviewerId
      );
    },
    isStart(row) {
      //判断考试是否开始
      let startLong = new Date(row.startTime).getTime();
      if (row.answer) {
        return false;
      } else if ((row.type == 0 || row.type >4) && row.nowtime) {
        return startLong < row.nowtime * 1;
      }
      return false;
    },
    //去考试
    toStartTest(index, row) {
      //在这里开始保存一个answers
      api.saveAnswers(
        { id: row.id, expid: row.expid, cid: row.cid, stuid: row.stuid },
        (response) => {
          if (response.data < 0) {
            // 超时了
            this.$utils.msg.warning(response.msg);
          } else {
            //打开考试页面
            this.$refs.startTest.open(
              row, //exam考试数据
              response.data, //返回的倒计时数据
              response.msg, //返回的answersid
              "考试 - " + row.name //考试名
            );
            //移除本行,以便回显
            this.listData.splice(index, 1);
          }
        }
      );
    },

    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page, {
        isHK: 0, //是不是作业
      });
      api.list(params, (response) => {
        this.listData = response.data.records;
        this.listLoading = false;
      });
      
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    
   
    //去面试按钮是否可点击
    allowUse(row) {
     
      if (row.myInterViewExam) {
        return true;
      } else {
        return false;
      }
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = { type: 1 };
      this.list();
    },
    closeExam() {
      this.list();
    },
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.el-tag {
  margin: 0 5px;
}
.hide-row {
  display: none; // 隐藏行样式
}
</style>
